module.exports = __webpack_public_path__ + "static/android-icon-192x192.08543fdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/android-icon-192x192.png
// module id = 543
// module chunks = 168707334958949